export const zoomConfigs = [
  { key: 'joinBeforeHost', label: 'Enable join before host' },
  { key: 'muteUponEntry', label: 'Mute participants upon entry' },
  { key: 'waitingRoom', label: 'Enable waiting room' },
  { key: 'autoRecording', label: 'Record the meeting automatically on the local computer' }
]
